module.exports = __webpack_public_path__ + "static/media/skill3.12643f67.gif";